export const createElementsWithClass = (count, tagName = 'div', className = '') => {
  return Array(count)
    .fill(0)
    .map(() => {
      const elem = document.createElement(tagName)
      elem.className = className
      return elem
    })
}
export const rem = (px, width) => {
  return `${px / 415}rem`
}
